import "./OpenedRequest.css";
import React, { useState, useEffect } from "react";
import { db } from "../../index";
import { ref, onValue } from "firebase/database";
import { useNavigate } from "react-router-dom";

const LoadingIndicator = () => (
    <div className="loading-indicator">
        <p>Загрузка...</p>
    </div>
  );
  
  const EmptyRequestsMessage = () => (
    <div className="empty-requests-message">
        <p>Данные не найдены <img src="./img/document-error.svg" alt="NotFoundData" /></p>
    </div>
  );

const OpenedRequestRow = ({ request, handleOpenForm }) => (
    <div key={request.id} onClick={() => handleOpenForm(request.id)} className="items-table__opened items-table">
        <div className="width_item ">
            <h2>{request.nameObject}</h2>
            <p>{request.address}</p>
        </div>
        <div className="width_item ">
            <p>{request.description}</p>
        </div>
        <div>
            <p>{request.date}</p>
        </div>
        <div className="items-table__opened-cell-last">
            <p>{request.createdDate}</p>
        </div>
        <div className="img-priority">
            <img src={request.selectedImage} alt="priority" />
        </div>
    </div>
);

export function OpenedRequest() {
    const [openedRequests, setOpenedRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const requestsRef = ref(db, "request");
        onValue(requestsRef, (snapshot) => {
            const openedRequests = [];
            snapshot.forEach((childSnapshot) => {
                openedRequests.push({ id: childSnapshot.key,...childSnapshot.val() });
            });
            openedRequests.sort((a, b) => {
                if (a.selectedImage === "./img/high-priority.svg" && b.selectedImage!== "./img/high-priority.svg") {
                    return -1;
                } else if (a.selectedImage!== "./img/high-priority.svg" && b.selectedImage === "./img/high-priority.svg") {
                    return 1;
                } else {
                    return 0;
                }
            });
            setOpenedRequests(openedRequests);
            setLoading(false);
        });
    }, []);

    const handleOpenForm = (openRequestID) => {
        navigate(`/openedRequest/${openRequestID}`);
    };

    return (
        <div className="table__opened">
            <h1>Открытые заявки</h1>
            <div className="items-table__opened media-opened">
                <span>Объект</span>
                <span>Проблема</span>
                <span>Ремонт</span>
                <span>Создана</span>
            </div>
            {loading ? (
                    <LoadingIndicator />
                ) : openedRequests.length === 0 ? (
                    <EmptyRequestsMessage />
                ) : (
                    openedRequests
                        .filter((request) => !request.idRequest)
                        .map((request) => (
                            <OpenedRequestRow key={request.id} request={request} handleOpenForm={handleOpenForm} />
                        ))
                )}
        </div>
    );
}